<script lang="ts" setup>
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const isSave = dialogRef.value.options.emits.isSave;

const handleSubmitOption = (isMultipleOptionForSamePassenger: boolean) => {
  isSave(isMultipleOptionForSamePassenger);
};
</script>
<template>
  <div>
    <div class="field grid">
      <div class="col-12 text-center text-xl font-bold mb-3">{{ $t('advance_quote.multiple_request') }}</div>
      <div class="col-12 text-center text-lg confirm_request">{{ $t('advance_quote.confirm_request') }}</div>
    </div>
    <div class="flex justify-content-between mt-5">
      <Button :label="$t('common.yes')" data-testid="yes-btn" @click="handleSubmitOption(true)"></Button>
      <Button :label="$t('common.no')" data-testid="no-btn" @click="handleSubmitOption(false)"></Button>
    </div>
  </div>
</template>
